/**
 * /operations/loans-agent — 3-agent loan workflow (Pack 8 v2).
 */
import { PageHeader } from "../components/ui";
import { AgentBadge } from "../components/ui/AgentBadge";

export function LoansAgentPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Loans Agent"
        subtitle="Tashghil drives applications. Mutaba'aa enforces Article 90 (1/3 cap) + Article 95 garnishment priority. Rawatib posts deductions. Khidmat handles intake."
      />
      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3"><AgentBadge agent="tashghil" /><h3 className="text-base font-semibold">Tashghil</h3></div>
        <p className="text-sm text-text-secondary">Eligibility check, approval routing, disbursement orchestration.</p>
      </section>
      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3"><AgentBadge agent="mutabaa" /><h3 className="text-base font-semibold">Mutaba'aa veto</h3></div>
        <ul className="text-sm text-text-secondary space-y-1.5">
          <li><strong>Article 90</strong> — total deductions ≤ 1/3 monthly basic wage (loan + payroll-time)</li>
          <li><strong>Article 95</strong> — court-ordered garnishment priority over voluntary deductions</li>
        </ul>
      </section>
      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3"><AgentBadge agent="rawatib" /><h3 className="text-base font-semibold">Rawatib</h3></div>
        <p className="text-sm text-text-secondary">Posts installment deductions per payroll period.</p>
      </section>
      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3"><AgentBadge agent="khidmat" /><h3 className="text-base font-semibold">Khidmat</h3></div>
        <p className="text-sm text-text-secondary">Employee loan request intake via WhatsApp / chat → delegates to Tashghil.</p>
      </section>
    </div>
  );
}
